export const navigationOffset = '55px'
